import React, { useState } from 'react';
import axios from 'axios';
import '../../purchase.css';

const PurchaseMedia = ({ show, onClose, media, purchasedMedia, author }) => {
    const [loading, setLoading] = useState(false);
    const [isPurchased, setIsPurchased] = useState(false);
    if (!show) return null;

    const handlePurchaseNow = async () => {
        try {
            setLoading(true);
            const user = JSON.parse(localStorage.getItem('user'));

            const requestBody = {
                media: [...new Set([...purchasedMedia, media._id])]
            };

            const response = await axios.put(`https://geoid-rest.vercel.app/users/${user.user._id}`, requestBody);
            setIsPurchased(true); // Update purchase status
        } catch (error) {
            console.error("There was an error updating purchase!", error);
        } finally {
            setLoading(false);
        }
    };

    const isAlreadyPurchased = purchasedMedia.includes(media._id);

    return (
        <div className="modal-overlay">
        {loading && (
            <div className="register-loading-overlay">
            <div className="register-spinner"></div>
            </div>
        )}
            <div className="modal-content">
                <button className="modal-close-button-purchase" onClick={onClose}>
                    &times;
                </button>

                {isPurchased || isAlreadyPurchased ? ( // Conditional rendering based on purchase status
                    <>
                        <p>You purchased this media</p>
                        <button className="purchase-button" onClick={() => window.open(media.imgSrc, '_blank')}>
                            Download
                        </button>
                    </>
                ) : (
                    <>
                        <h2>{media.name}</h2>
                        <p>Author: {author}</p>
                        <p><strong>Price: RM 10</strong></p>
                        <button onClick={handlePurchaseNow} className="purchase-button">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-cash-stack" viewBox="0 0 16 16">
                                <path d="M1 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1zm7 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/>
                                <path d="M0 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V7a2 2 0 0 1-2-2z"/>
                            </svg>&nbsp;
                            Purchase Now
                        </button>
                    </>
                )}
            </div>
        </div>
    );
};

export default PurchaseMedia;